import { JSX } from 'react'

import SentimentTracker from './sentiment-tracker'

import styles from './insight.module.scss'

export default function Insight(): JSX.Element {
  return (
    <>
      {
        <div className={styles.insight}>
          <SentimentTracker />
        </div>
      }
    </>
  )
}
